import { useTranslation } from 'react-i18next';

import { useAuthUser } from 'auth/hooks';
import { Error, PageLayout, PageTitle } from 'core/components';
import { StatusCode } from 'core/constants';
import { ConsumerRestart } from 'dashboard/components';

export const ManageConsumersPage = () => {
  const { t } = useTranslation();

  const { user, isFetched } = useAuthUser();

  const title = t('titleManageConsumers');

  if (isFetched && !user?.admin) {
    return <Error statusCode={StatusCode.ACCESS_DENIED} />;
  }

  return (
    <PageLayout scrollable title={title}>
      <PageTitle title={title} />
      <ConsumerRestart />
    </PageLayout>
  );
};
